import { supportedDeserializerTypes, } from "../types";
import { htmlDeserializer } from "./deserializer/html";
const protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;
const localhostDomainRE = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/;
const nonLocalhostDomainRE = /^[^\s\.]+\.\S{2,}$/;
export function isUrl(url) {
    if (typeof url !== "string") {
        return false;
    }
    const match = url.match(protocolAndDomainRE);
    if (!match) {
        return false;
    }
    const everythingAfterProtocol = match[1];
    if (!everythingAfterProtocol) {
        return false;
    }
    if (localhostDomainRE.test(everythingAfterProtocol) ||
        nonLocalhostDomainRE.test(everythingAfterProtocol)) {
        return true;
    }
    return false;
}
export const valueFromString = (value, size, scale, valueIfNaN = 0) => {
    // @ts-ignore
    if (value === "auto")
        return "auto";
    if (value === "")
        return 0;
    if (typeof value === "number")
        return value;
    if (value.endsWith("%")) {
        const result = (parseFloat(value.substring(0, value.length - 1)) * size) / 100 / scale;
        return isNaN(result) ? valueIfNaN : result;
    }
    else if (value.endsWith("px")) {
        const result = parseFloat(value.substring(0, value.length - 2)) / scale;
        return isNaN(result) ? valueIfNaN : result;
    }
    const result = parseFloat(value) / scale;
    return isNaN(result) ? valueIfNaN : result;
};
export const pxToPercents = (value, size) => {
    if (value === "auto")
        return "auto";
    let formattedValue = parseInt(value);
    if (value.endsWith("px")) {
        formattedValue = parseFloat(value.substring(0, value.length - 2));
    }
    return `${Math.ceil((formattedValue / size) * 100).toString()}%`;
};
export const deserialize = (data, type) => {
    switch (type) {
        case "text/html":
            const html = data.getData("text/html");
            const document = new DOMParser().parseFromString(html, "text/html");
            console.log(document.body);
            return htmlDeserializer(document.body);
        default:
            return null;
    }
};
export const getPreferedFormat = (formats) => {
    if (!formats.every((format) => supportedDeserializerTypes.includes(format)))
        throw new Error("Type is not supported");
    let type = undefined;
    for (let supportedType of supportedDeserializerTypes) {
        for (let format of formats) {
            if (format === supportedType) {
                type = supportedType;
            }
            break;
        }
        if (type !== undefined) {
            break;
        }
    }
    return type;
};
export const inlineStyleToObject = (inlineStyle) => {
    const splittedStyle = inlineStyle.replace(/\\n/g, "").split(";");
    return splittedStyle.reduce((prev, curr) => {
        const [key, value] = curr.split(":");
        return Object.assign(Object.assign({}, prev), { [key]: value });
    }, {});
};
const styleTransformations = {
    background: {
        key: "backgroundColor",
    },
    // Word, PowerPoint, G>oogl Docs
    "font-size": {
        key: "fontSize",
        transform: (value) => {
            if (value.endsWith("pt")) {
                const fontSizeScale = 3;
                const valueWitoutPt = value.substring(0, value.length - 2);
                const scaledValue = parseInt(valueWitoutPt) * fontSizeScale;
                return Math.round(scaledValue).toString();
            }
            return value;
        },
    },
    // Specially for Canva
    " --font-size": {
        key: "fontSize",
        transform: (value) => {
            if (value.endsWith("px")) {
                const fontSizeScale = 1.5;
                const valueWitoutPx = value.substring(0, value.length - 2);
                const scaledValue = parseInt(valueWitoutPx) * fontSizeScale;
                return Math.round(scaledValue).toString();
            }
            return value;
        },
    },
    "font-family": {
        key: "font",
        transform: (value) => value.split(",")[0],
    },
    color: {
        transform: (value) => {
            const blackValues = ["#000", "#000000", "black", "rgb(0, 0, 0)"];
            if (blackValues.includes(value.trim()))
                return "#FFFFFF";
            return value;
        },
        defaultValue: "#FFFFFF",
    },
    "font-weight": {
        key: "bold",
        transform: (value) => {
            if (parseInt(value) > 400)
                return true;
            return false;
        },
    },
    "font-style": {
        key: "italic",
        transform: (value) => {
            if (value === "italic")
                return true;
            return false;
        },
    },
    "text-align": {
        key: "align",
    },
};
export const styleToSlateMarkAttributes = (style) => {
    const transformedValue = Object.keys(style).reduce((prev, curr) => {
        var _a, _b, _c;
        const transformation = styleTransformations === null || styleTransformations === void 0 ? void 0 : styleTransformations[curr];
        const value = style[curr];
        const mappedKey = (_a = transformation === null || transformation === void 0 ? void 0 : transformation.key) !== null && _a !== void 0 ? _a : curr;
        const transformedValue = (_c = (_b = transformation === null || transformation === void 0 ? void 0 : transformation.transform) === null || _b === void 0 ? void 0 : _b.call(transformation, value)) !== null && _c !== void 0 ? _c : value;
        return Object.assign(Object.assign({}, prev), { [mappedKey]: transformedValue });
    }, {});
    const defaultValues = Object.keys(styleTransformations).filter((key) => styleTransformations[key].defaultValue !== undefined);
    defaultValues.forEach((key) => {
        if ((transformedValue === null || transformedValue === void 0 ? void 0 : transformedValue[key]) !== undefined)
            return;
        const defaultValue = styleTransformations[key].defaultValue;
        if (!defaultValue)
            return;
        transformedValue[key] = defaultValue;
    });
    return transformedValue;
};
